import Cookies from 'js-cookie'
import { createFileRoute, Outlet, useMatches } from '@tanstack/react-router'
import PrivateRoute from '@/providers/private-routes'
import { useState } from 'react'
import { GlobalAISheet } from '@/components/layout/global-ai-sheet'
import { Button } from '@/components/ui/button'
import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'
// import { SearchProvider } from '@/context/search-context'
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar'
import { AppSidebar } from '@/components/layout/app-sidebar'
import { Header } from '@/components/layout/header'
import { UniversalBreadcrumb } from '@/components/layout/universal-breadcrumb'
import { NotificationBell } from '@/components/notifications'
// import { Search } from '@/components/search'
import { ThemeSwitch } from '@/components/theme-switch'
import { useAuth } from '@/context/auth-context'

export const Route = createFileRoute('/_authenticated')({
  component: RouteComponent,
})

function RouteComponent() {
  const defaultOpen = Cookies.get('sidebar:state') !== 'false'
  const { isImpersonated, user, stopImpersonating } = useAuth()

  const matches = useMatches()
  
  const [isGlobalAiOpen, setIsGlobalAiOpen] = useState(false)

  // Disable global AI if viewing a candidate profile page (which has job-specific Xera AI active)
  const isCandidatePage = matches.some((match) =>
    match.routeId.endsWith('candidate/$id') || match.routeId.includes('candidate.$id')
  )

  const isSpecialRoute = matches.some((match) =>
    [
      '/_authenticated/jobs/$jobId/assessments/create/ai',
      '/_authenticated/jobs/$jobId/assessments/create/from-template',
      '/_authenticated/jobs/$jobId/assessments/create/manual',
      '/_authenticated/jobs/$jobId/assessments/create/',
    ].includes(match.routeId)
  )
  return (
    <PrivateRoute>
      {/* <SearchProvider> */}
      {isSpecialRoute ? (
        <SidebarProvider defaultOpen={defaultOpen}>
          <SidebarInset>
            {isImpersonated && (
              <div className='bg-amber-600 dark:bg-amber-500 text-white px-4 py-2 text-xs font-semibold flex items-center justify-between shadow-md select-none shrink-0 z-50 animate-in fade-in slide-in-from-top duration-300'>
                <div className='flex items-center gap-2'>
                  <span className='relative flex h-2 w-2'>
                    <span className='animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75'></span>
                    <span className='relative inline-flex rounded-full h-2 w-2 bg-red-500'></span>
                  </span>
                  <span>You are currently impersonating <strong>{user?.email}</strong>. Every action is tracked for security auditing.</span>
                </div>
                <button
                  onClick={stopImpersonating}
                  className='bg-white/10 hover:bg-white/20 active:bg-white/30 text-white border border-white/20 rounded px-2.5 py-1 transition-colors text-[10px] uppercase tracking-wider font-bold'
                >
                  Exit Impersonation
                </button>
              </div>
            )}
            <Header>
              <UniversalBreadcrumb />
              <div className='ml-auto flex items-center space-x-4'>
                {/* AI-ROS Command Center - In development (enabled on test branch) */}
                {/* <TooltipProvider delayDuration={0}>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <div className="relative">
                        <Button
                          variant='ghost'
                          size='icon'
                          disabled={isCandidatePage}
                          onClick={() => setIsGlobalAiOpen(true)}
                          className={cn(
                            "relative h-9 w-9 rounded-full transition-all duration-300 flex items-center justify-center border",
                            isCandidatePage 
                              ? "opacity-40 cursor-not-allowed border-zinc-200 dark:border-zinc-800 bg-transparent"
                              : "border-zinc-200 dark:border-zinc-800 hover:border-violet-500/50 hover:bg-zinc-50 dark:hover:bg-zinc-900 shadow-sm hover:shadow-[0_0_15px_rgba(124,58,237,0.15)]"
                          )}
                        >
                          <img
                            src="https://cdn.xecubes.com/static/Xecubes_AI_LOGO.svg"
                            alt="AI-ROS"
                            className={cn(
                              "h-4 w-4 object-contain transition-all duration-300",
                              isCandidatePage ? "grayscale opacity-50 pointer-events-none" : "hover:scale-110"
                            )}
                          />
                        </Button>
                      </div>
                    </TooltipTrigger>
                    <TooltipContent className="rounded-xl border-zinc-800 bg-zinc-900/90 p-2 text-white shadow-2xl backdrop-blur-md z-50">
                      <p className="text-[10px] font-bold">
                        {isCandidatePage 
                          ? "Global AI disabled (Candidate Xera is active)" 
                          : "Open AI-ROS Command Center"}
                      </p>
                    </TooltipContent>
                  </Tooltip>
                </TooltipProvider> */}
                <NotificationBell />
                <ThemeSwitch />
              </div>
            </Header>
            <Outlet />
          </SidebarInset>
        </SidebarProvider>
      ) : (
        <SidebarProvider defaultOpen={defaultOpen}>
          <AppSidebar />
          <SidebarInset>
            {isImpersonated && (
              <div className='bg-amber-600 dark:bg-amber-500 text-white px-4 py-2 text-xs font-semibold flex items-center justify-between shadow-md select-none shrink-0 z-50 animate-in fade-in slide-in-from-top duration-300'>
                <div className='flex items-center gap-2'>
                  <span className='relative flex h-2 w-2'>
                    <span className='animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75'></span>
                    <span className='relative inline-flex rounded-full h-2 w-2 bg-red-500'></span>
                  </span>
                  <span>You are currently impersonating <strong>{user?.email}</strong>. Every action is tracked for security auditing.</span>
                </div>
                <button
                  onClick={stopImpersonating}
                  className='bg-white/10 hover:bg-white/20 active:bg-white/30 text-white border border-white/20 rounded px-2.5 py-1 transition-colors text-[10px] uppercase tracking-wider font-bold'
                >
                  Exit Impersonation
                </button>
              </div>
            )}
            <Header>
              <UniversalBreadcrumb />
              <div className='ml-auto flex items-center space-x-4'>
                {/* AI-ROS Command Center - In development (enabled on test branch) */}
                {/* <TooltipProvider delayDuration={0}>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <div className="relative">
                        <Button
                          variant='ghost'
                          size='icon'
                          disabled={isCandidatePage}
                          onClick={() => setIsGlobalAiOpen(true)}
                          className={cn(
                            "relative h-9 w-9 rounded-full transition-all duration-300 flex items-center justify-center border",
                            isCandidatePage 
                              ? "opacity-40 cursor-not-allowed border-zinc-200 dark:border-zinc-800 bg-transparent"
                              : "border-zinc-200 dark:border-zinc-800 hover:border-violet-500/50 hover:bg-zinc-50 dark:hover:bg-zinc-900 shadow-sm hover:shadow-[0_0_15px_rgba(124,58,237,0.15)]"
                          )}
                        >
                          <img
                            src="https://cdn.xecubes.com/static/Xecubes_AI_LOGO.svg"
                            alt="AI-ROS"
                            className={cn(
                              "h-4 w-4 object-contain transition-all duration-300",
                              isCandidatePage ? "grayscale opacity-50 pointer-events-none" : "hover:scale-110"
                            )}
                          />
                        </Button>
                      </div>
                    </TooltipTrigger>
                    <TooltipContent className="rounded-xl border-zinc-800 bg-zinc-900/90 p-2 text-white shadow-2xl backdrop-blur-md z-50">
                      <p className="text-[10px] font-bold">
                        {isCandidatePage 
                          ? "Global AI disabled (Candidate Xera is active)" 
                          : "Open AI-ROS Command Center"}
                      </p>
                    </TooltipContent>
                  </Tooltip>
                </TooltipProvider> */}
                <NotificationBell />
                <ThemeSwitch />
              </div>
            </Header>
            <Outlet />
          </SidebarInset>
        </SidebarProvider>
      )}
      {/* </SearchProvider> */}
      <GlobalAISheet isOpen={isGlobalAiOpen} onOpenChange={setIsGlobalAiOpen} />
    </PrivateRoute>
  )
}

